import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { didYouKnow } from '../extras/constants';
import { ChevronRight } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

const RightSideBar = ({ setSectionId }) => {
  const { name, email, company_name, role } =
    useSelector((state) => state?.authReducer?.userData) || {};

  const [randomFact, setRandomFact] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const userData = useSelector((state) => state?.authReducer?.userData);

  const isOnRegisterPage = location.pathname === `/${role}/register`;

  const handleNavigation = (path, sectionId) => {
    if (path) {
      if (location.pathname === path) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      } else {
        navigate(path);
      }
    } else if (sectionId && isOnRegisterPage && setSectionId) {
      setSectionId(sectionId);
    } else if (sectionId && !isOnRegisterPage) {
      // Navigate to register page first, then set section
      navigate(`/${role}/register`, {
        state: { targetSection: sectionId },
      });
    }
  };

  const navigationItems = [
    {
      text: 'Dashboard',
      path: `/${role}/dashboard`,
    },
    {
      text: 'Edit Profile',
      path: `#`,
    },
    {
      text: 'View Plants',
      sectionId: 7,
    },
    {
      text: 'View Machines',
      sectionId: 8,
    },
  ];

  // Set a new random fact on initial render
  useEffect(() => {
    const getRandomFact = () => {
      const fact =
        didYouKnow[Math.floor(Math.random() * didYouKnow.length)].fact;
      setRandomFact(fact);
    };
    getRandomFact();
  }, []);

  // Effect to handle section navigation when coming from another page
  useEffect(() => {
    if (isOnRegisterPage && location.state?.targetSection && setSectionId) {
      setSectionId(location.state.targetSection);
      // Clean up the state after using it
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [isOnRegisterPage, location.state, setSectionId, navigate]);

  return (
    <div className="font-roboto pl-2 pr-7">
      <div className="flex my-4 items-center justify-start gap-5">
        <Avatar className="h-24 w-24">
          <AvatarFallback>
            {/* make it so that if a value is undefined it is not displayed */}
            {name.split(' ')[0][0] + name.split(' ')[1][0]}
          </AvatarFallback>
        </Avatar>
        <div className="flex flex-col">
          <h3 className="text-lg font-semibold text-gray-700 mb-1">
            Hello, {name.split(' ')[0]}
          </h3>
          <p className="text-gray-500">{company_name}</p>
          <p className="text-gray-500">{email}</p>
        </div>
      </div>

      <div className="grid gap-3 grid-cols-4 justify-between my-6">
        <div className="production-this-month flex flex-col col-span-1">
          <span className="font-semibold text-3xl mb-2 text-lightPurple hover:text-darkerPurple ease-in duration-100">
            65
          </span>
          <span className="text-sm text-gray-400">Production This Month</span>
        </div>
        <div className="projects-done flex flex-col col-span-1">
          <span className="font-semibold text-3xl mb-2 text-lightPurple hover:text-darkerPurple ease-in duration-100">
            55
          </span>
          <span className="text-sm text-gray-400">Projects done</span>
        </div>
        <div className="in-progress flex flex-col col-span-1">
          <span className="font-semibold text-3xl mb-2 text-lightPurple hover:text-darkerPurple ease-in duration-100">
            12
          </span>
          <span className="text-sm text-gray-400">In Progress</span>
        </div>
        <div className="overdue flex flex-col col-span-1">
          <span className="font-semibold text-3xl mb-2 text-lightPurple hover:text-darkerPurple ease-in duration-100">
            2
          </span>
          <span className="text-sm text-gray-400">Overdue</span>
        </div>
      </div>

      <div className="did-you-know flex flex-col justify-start">
        <div className="text-lightPurple font-roboto font-semibold hover:text-darkPurple mb-1">
          Did you know?
        </div>
        <div className="text-sm text-gray-400">"{randomFact}"</div>
      </div>

      <div className="Quick-Navigation-menu font-semibold text-md flex flex-col my-6 justify-start">
        <div>
          {navigationItems.map((item, index) => {
            const isCurrentPath = item.path && location.pathname === item.path;

            return (
              <div
                key={index}
                className="flex gap-2 justify-start items-center mb-2 text-lightPurple hover:text-darkerPurple ease-in duration-100"
              >
                <ChevronRight size={20} className="text-lightPurple" />
                <button
                  className={`text-${item.text.replace(' ', '-')}`}
                  onClick={() => handleNavigation(item.path, item.sectionId)}
                >
                  {item.text}
                </button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RightSideBar;
